import { OrderAnalyticsApiClient } from '@fourthwall/services/dist/OrderAnalyticsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useOfferPendingOrdersQuery = createQueryHook(
  OrderAnalyticsApiClient.getOfferPendingOrders,
  {
    queryKey: ['offerPendingOrders'],
  },
)
